import { MapPin, Clock, Mail, ArrowUpRight } from "lucide-react";
import { VENUE } from "@/data/content";
import { Reveal, SectionHead } from "@/components/site/Reveal";

const Row = ({ icon: Icon, k, children, testid }) => (
  <div className="flex gap-5 py-6 border-b border-white/10" data-testid={testid}>
    <Icon size={20} className="accent-text shrink-0 mt-1" strokeWidth={1.5} />
    <div>
      <p className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-500">{k}</p>
      <div className="mt-2 text-slate-200 leading-relaxed">{children}</div>
    </div>
  </div>
);

export const Venue = () => (
  <section id="venue" data-testid="venue-section" className="relative">
    <div className="section">
      <SectionHead eyebrow="Dates, Venue & Scheduling" testid="venue-title" title={<>12–20 December<br /><span className="accent-text">2026</span></>} />
      <div className="grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <Row icon={MapPin} k="Venue" testid="venue-address">
            <p className="font-display text-2xl font-bold tracking-tight">{VENUE.name}</p>
            <p className="text-slate-400">{VENUE.address}</p>
          </Row>
          <Row icon={Clock} k="Operating window" testid="venue-hours">
            <p className="font-display text-2xl font-bold tracking-tight">8:00am – 2:00pm</p>
            <p className="text-slate-400 text-sm">Elite coaching daily. Each age group has its own training time within this window.</p>
          </Row>
          <Row icon={Mail} k="Session times" testid="venue-schedule-note">
            <p className="text-sm text-slate-300">Your child will <strong className="text-white">not</strong> attend from 8am to 2pm daily. Each group has its own allocated session time. Exact times will be emailed by <span className="accent-text">25 November 2026</span>, or earlier once confirmed.</p>
          </Row>
          <a href={VENUE.directions} target="_blank" rel="noreferrer" className="btn-ghost mt-8" data-testid="venue-directions-link">
            Get directions <ArrowUpRight size={16} />
          </a>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <div className="relative h-[380px] lg:h-full min-h-[380px] rounded-3xl border border-white/10 overflow-hidden">
            <iframe
              title="Venue map"
              data-testid="venue-map"
              src={VENUE.mapEmbed}
              className="absolute inset-0 w-full h-full"
              style={{ filter: "invert(92%) hue-rotate(180deg) saturate(0.6) brightness(0.9)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
